import { render, staticRenderFns } from "./b-ticket-policies.vue?vue&type=template&id=5c122f7d&scoped=true"
import script from "./b-ticket-policies.vue?vue&type=script&lang=ts"
export * from "./b-ticket-policies.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-policies.vue?vue&type=style&index=0&id=5c122f7d&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c122f7d",
  null
  
)

export default component.exports